import { FC, Fragment, ReactNode } from "react";
import InteractiveCard from "./InteractiveCard";
import { CheckMark, Star } from "@/icons";
import { getParagraphs } from "./getParagraphs";

type InfoTextSectionProps = {
  header?: string;
  description?: string;
};

export const processTextWithIcons = (text: string): ReactNode[] | string => {
  const iconRegex = /({{\s*star\s*}}|{{\s*check\s*}})/;
  if (!iconRegex.test(text)) return text;

  return text.split(iconRegex).map((part, partIndex) => {
    const cleanPart = part.trim().toLowerCase();
    if (cleanPart === "{{star}}") return <Star key={`star-${partIndex}`} />;
    if (cleanPart === "{{check}}")
      return (
        <CheckMark
          key={`check-${partIndex}`}
          className="text-swdc-black-600 mb-0.5 inline-block h-4 w-4"
        />
      );
    return part;
  });
};

export const processContent = (content: ReactNode | ReactNode[]): ReactNode => {
  if (Array.isArray(content)) {
    return content.map((child, childIndex) => (
      <Fragment key={`content-${childIndex}`}>{processContent(child)}</Fragment>
    ));
  }
  if (typeof content === "string") {
    return processTextWithIcons(content);
  }
  return content;
};

const InfoTextSection: FC<InfoTextSectionProps> = ({ header, description }) => (
  <InteractiveCard header={header}>
    {description && (
      <div className="text-body-m text-swdc-gray-400 my-6 font-normal">
        {getParagraphs(description).map((text, paragraphIndex) => (
          <p key={`paragraph-${paragraphIndex}`} className="mb-7 last:mb-0">
            {processTextWithIcons(text)}
          </p>
        ))}
      </div>
    )}
  </InteractiveCard>
);

export default InfoTextSection;
